module.exports = __webpack_public_path__ + "img/bi.c4a568ac.png";